import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
  Autocomplete, Box, IconButton, TextField
} from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import _ from 'lodash'
import * as pdfjsLib from 'pdfjs-dist/webpack.mjs'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import 'material-icons/iconfont/outlined.css'

import CheckBox from '@components/inputs/checkBox'
import Table from '@components/table'
import Select from '@components/inputs/select'
import Loading from '@components/loading'
import {
  TextPopUp,
  StyledPopup,
} from '@components/table/beneficiaryList/styles'

import colors from '@settings/styleSettings'
import { getDataFromLaboratoryText } from '@util/LaboratoryUtil'
import ExamTypesEnum from '@util/ExamTypesEnum'
import BeneficiaryFileStatus from '@util/BeneficiaryFileStatus'
import showToast from '@util/ToastUtil'

import {
  Container,
  FilesContainer,
  FileDetails,
  Identifier,
  StatusContainer,
  ConfirmContainer,
} from './styles'

import {
  getBeneficiariesToSelect as getBeneficiariesAction,
  checkBeneficiariesRead as checkBeneficiariesReadAction,
} from '@actions/beneficiary'

const ChooseFiles = ({
  files,
  filesData,
  setFilesData,
  beneficiariesToSelect,
  checkedBeneficiaries,
  getBeneficiariesToSelect,
  checkBeneficiariesRead,
}) => {
  // Log inicial para props na renderização
  console.log('[ChooseFiles] Render/Props recebidas:', {
    files,
    filesData,
    beneficiariesToSelect,
    checkedBeneficiaries,
  })

  const [beneficiariesOptions, setBeneficiariesOptions] = useState([])
  const [benSearchLoading, setBenSearchLoading] = useState(false)
  let delayTimer
  const navigate = useNavigate()
  const { insurance } = useParams()

  const allRead = () => {
    for (let i = 0; i < filesData.length; i += 1) {
      if (filesData[i] === undefined) return false
    }
    return true
  }

  function hasFileError(fileData) {
    if (fileData?.confirmed) {
      return false
    }
    if (fileData) {
      return fileData.findStatus
        ? fileData.findStatus === BeneficiaryFileStatus.withError.id
        : true
    }
    return true
  }

  const setLaboratorialData = (pages, index) => {
    console.log(
      `[setLaboratorialData] Index: ${index}, Páginas recebidas:`,
      pages
    )
    const aux = filesData
    let allPages = []
    _.forEach(pages, (page) => {
      allPages = allPages.concat(page)
    })
    const extractedData = getDataFromLaboratoryText(allPages)
    console.log(
      `[setLaboratorialData] Dados extraídos para o índice ${index}:`,
      extractedData
    )
    aux.splice(index, 1, extractedData)
    setFilesData([...aux])
  }

  const getPdfText = async (data) => {
    console.log('[getPdfText] Lendo dados do PDF.')
    const doc = await pdfjsLib.getDocument({ data }).promise
    const pageTexts = Array.from({ length: doc.numPages }, async (v, i) => {
      return (await (await doc.getPage(i + 1)).getTextContent()).items.map(
        (token) => token.str
      )
    })
    return Promise.all(pageTexts)
  }

  const onLoadFile = async (reader, index) => {
    console.log(`[onLoadFile] Arquivo carregado para o índice ${index}.`)
    try {
      const pdfText = await getPdfText(reader.result)
      console.log(
        `[onLoadFile] Texto extraído do PDF para o índice ${index}:`,
        pdfText
      )
      setLaboratorialData(pdfText, index)
    } catch (error) {
      console.error(
        `[onLoadFile] Erro ao processar PDF no índice ${index}:`,
        error
      )
    }
  }

  const readText = async (file, index) => {
    console.log(`[readText] Lendo arquivo no índice ${index}:`, file.name)
    const reader = new FileReader()
    reader.readAsBinaryString(file)
    reader.onload = () => onLoadFile(reader, index)
    reader.onerror = (error) => console.error(
      `[readText] Erro do FileReader para o índice ${index}:`,
      error
    )
  }

  useEffect(() => {
    console.log(
      '[useEffect Mount] Componente montado. Buscando opções iniciais de beneficiários.'
    )
    getBeneficiariesOptions('')
  }, [])

  useEffect(() => {
    console.log('[useEffect files] Prop "files" mudou:', files)
    if (!files.length) {
      console.log('[useEffect files] Nenhum arquivo, navegando de volta.')
      navigate(`/${insurance}/acompanhamento/importar-exames`)
    } else if (!allRead()) {
      console.log('[useEffect files] Iniciando leitura dos arquivos.')
      _.map(files, (file, index) => readText(file, index))
    }
  }, [files])

  useEffect(() => {
    console.log(
      '[useEffect beneficiariesToSelect] Prop "beneficiariesToSelect" (Redux) mudou:',
      beneficiariesToSelect
    )
    if (beneficiariesToSelect) {
      const filteredOptions = _.filter(
        beneficiariesToSelect,
        ({ nameAndCpf }) => nameAndCpf && !nameAndCpf.includes('*')
      )
      console.log(
        '[useEffect beneficiariesToSelect] Opções filtradas:',
        filteredOptions
      )
      setBeneficiariesOptions(filteredOptions)
    }
  }, [beneficiariesToSelect])

  useEffect(() => {
    const canCheck = allRead()
      && !checkedBeneficiaries
      && files.length === filesData.length
      && files.length !== 0
      && filesData.length !== 0
    console.log(
      '[useEffect filesData, checkedBeneficiaries] Verificando se pode chamar checkBeneficiariesRead:',
      canCheck
    )
    if (canCheck) {
      const beneficiaryNames = _.map(filesData, ({ beneficiaryFileName }) => (beneficiaryFileName !== '' ? beneficiaryFileName : 'empty'))
      console.log(
        '[useEffect filesData, checkedBeneficiaries] Chamando checkBeneficiariesRead com:',
        { beneficiaryNames }
      )
      checkBeneficiariesRead({
        beneficiaryNames,
      })
    }
  }, [filesData, checkedBeneficiaries])

  useEffect(() => {
    console.log(
      '[useEffect checkedBeneficiaries] Prop "checkedBeneficiaries" (Redux) mudou:',
      checkedBeneficiaries
    )
    if (checkedBeneficiaries) {
      const updatedFilesData = _.map(filesData, (fileData, index) => {
        const aux = { ...fileData }
        if (aux.findStatus !== BeneficiaryFileStatus.withError.id) {
          aux.findStatus = checkedBeneficiaries[index].findStatus
        }
        if (
          checkedBeneficiaries[index].findStatus
          === BeneficiaryFileStatus.found.id
        ) {
          aux.beneficiaryFileName = checkedBeneficiaries[index].nameAndCpf
          aux.selectedBeneficiary = checkedBeneficiaries[index]
        }
        return aux
      })
      console.log(
        '[useEffect checkedBeneficiaries] Atualizando filesData com informações verificadas:',
        updatedFilesData
      )
      setFilesData(updatedFilesData)
    }
  }, [checkedBeneficiaries])

  const onChangeAutoInput = (e, index) => {
    if (e) {
      const { value } = e.target
      console.log(`[onChangeAutoInput] Index: ${index}, Valor: "${value}"`)
      const aux = [...filesData]
      getBeneficiariesOptions(value)
      aux[index].beneficiaryFileName = value
      aux[index].selectedBeneficiary = null
      aux[index].findStatus = checkedBeneficiaries[index]?.findStatus
      setFilesData(aux)
    }
  }

  const setExamType = (e, index) => {
    console.log(`[setExamType] Index: ${index}, Tipo de exame:`, e)
    const aux = [...filesData]
    aux[index].examType = e
    setFilesData(aux)
  }

  const getBeneficiariesOptions = (beneficiaryName) => {
    console.log(
      `[getBeneficiariesOptions] Agendando busca para: "${beneficiaryName}"`
    )
    clearTimeout(delayTimer)
    setBenSearchLoading(true)
    delayTimer = setTimeout(() => {
      console.log(
        `[getBeneficiariesOptions] Executando busca para: "${beneficiaryName}"`
      )
      getBeneficiariesToSelect(
        {
          searchTerm: beneficiaryName,
        },
        () => {
          console.log(
            `[getBeneficiariesOptions] Busca concluída para: "${beneficiaryName}"`
          )
          setBenSearchLoading(false)
        }
      )
    }, 1500) // seg
  }

  const checkIfValueIsAlreadySelected = (value) => {
    return _.find(
      filesData,
      ({ selectedBeneficiary }) => selectedBeneficiary && selectedBeneficiary.id === value.id
    )
  }

  const setSelectedBeneficiary = (value, index) => {
    console.log(
      `[setSelectedBeneficiary] Index: ${index}, Beneficiário selecionado:`,
      value
    )
    if (value) {
      const aux = [...filesData]
      if (checkIfValueIsAlreadySelected(value)) {
        console.warn(
          '[setSelectedBeneficiary] Beneficiário já selecionado:',
          value
        )
        showToast('error', 'Beneficiário já selecionado')
        aux[index].selectedBeneficiary = null
        aux[index].beneficiaryFileName = ''
        aux[index].confirmed = false
      } else {
        aux[index] = { ...aux[index], ...value }
        aux[index].beneficiaryFileName = value.nameAndCpf
        aux[index].confirmed = false
        aux[index].selectedBeneficiary = value
        setFilesData(aux)
      }
    }
  }

  const confirmField = (index) => {
    console.log(
      `[confirmField] Campo de confirmação clicado para o índice ${index}. Estado atual: ${filesData[index]?.confirmed}`
    )
    if (
      BeneficiaryFileStatus.found.id === filesData[index].findStatus
      || filesData[index].findStatus === 0
    ) {
      const aux = [...filesData]
      aux[index].confirmed = !aux[index].confirmed
      console.log(
        `[confirmField] Novo estado de confirmação para o índice ${index}: ${aux[index].confirmed}`
      )
      setFilesData(aux)
    } else {
      console.log(
        `[confirmField] Confirmação negada para o índice ${index} devido ao status: ${filesData[index].findStatus}`
      )
    }
  }

  const getRowStatus = (index) => {
    if (filesData[index]) {
      const { findStatus } = filesData[index]
      if (findStatus === BeneficiaryFileStatus.found.id || findStatus === 0) {
        return (
          <span
            className="material-symbols-outlined"
            style={{
              color: colors.primary,
              cursor: 'pointer',
            }}
          >
            check
          </span>
        )
      }
      if (findStatus) {
        const { color, icon, label } = BeneficiaryFileStatus[findStatus]
        return (
          <StyledPopup
            trigger={() => (
              <div>
                <span
                  className="material-symbols-outlined"
                  style={{
                    color,
                    cursor: 'pointer',
                  }}
                >
                  {icon}
                </span>
              </div>
            )}
            on={['hover', 'focus', 'click']}
            position="top"
            closeOnDocumentClick
          >
            <TextPopUp>{label}</TextPopUp>
          </StyledPopup>
        )
      }
    }
    return <Loading color={colors.strongGray} />
  }

  const disableAutoComplete = (fileData) => fileData?.confirmed
  const listFiles = () => {
    const dataHeads = [
      'n°',
      'Arquivo',
      'Status',
      'Nome/CPF do beneficiário',
      'Tipo de exame',
      'Confirmado',
    ]
    const data = _.map(files, (file, index) => [
      <Identifier>{`${index + 1}.`}</Identifier>,
      <FileDetails>
        <span
          className="material-symbols-outlined"
          style={{
            color: hasFileError(filesData[index])
              ? 'orange'
              : colors.strongGray,
            marginRight: '16px',
          }}
        >
          lab_profile
        </span>
        {hasFileError(filesData[index]) ? (
          <span style={{ color: 'orange' }}>{file.name}</span>
        ) : (
          <span>{file.name}</span>
        )}
      </FileDetails>,
      <StatusContainer>{getRowStatus(index)}</StatusContainer>,
      <Autocomplete
        sx={{
          display: 'flex',
          flexDirection: 'column',
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            height: '40px',
            padding: '0',
            paddingLeft: '8px',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: hasFileError(filesData[index])
                ? 'orange'
                : colors.strongGray,
              borderWidth: '1px',
            },
          },
        }}
        options={beneficiariesOptions}
        id="clear-on-escape"
        clearOnEscape
        aria-label="selecione"
        value={
          filesData[index] && filesData[index].selectedBeneficiary
            ? filesData[index].selectedBeneficiary
            : null
        }
        noOptionsText={
          benSearchLoading ? 'Pesquisando...' : 'Opções não encontradas'
        }
        isOptionEqualToValue={(opt, value) => opt?.id === value?.id}
        onChange={(e, value) => setSelectedBeneficiary(value, index)}
        inputValue={
          filesData[index] ? filesData[index].beneficiaryFileName : ''
        }
        onInputChange={(e) => onChangeAutoInput(e, index)}
        getOptionLabel={({ nameAndCpf }) => nameAndCpf || ''}
        renderInput={(params) => {
          return (
            <Box position="relative">
              <TextField {...params} placeholder="Selecione..." />
              {disableAutoComplete(filesData[index]) && (
                <IconButton
                  style={{
                    position: 'absolute',
                    right: 2,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'none',
                  }}
                >
                  <span className="material-symbols-outlined"> block </span>
                </IconButton>
              )}
            </Box>
          )
        }}
        disabled={disableAutoComplete(filesData[index])}
        forcePopupIcon={!disableAutoComplete(filesData[index])}
      />,
      <Select
        value={filesData[index]?.examType}
        onChange={(e) => setExamType(e, index)}
        options={ExamTypesEnum.list}
        disabled={!hasFileError(filesData[index])}
      />,
      <ConfirmContainer>
        <CheckBox
          checked={filesData[index]?.confirmed}
          onChange={() => confirmField(index)}
        />
      </ConfirmContainer>,
    ])

    if (!files) return null
    return (
      <FilesContainer>
        <Table
          striped
          data={data}
          dataHeads={dataHeads}
          dataWidth={['5%', '30%', '5%', '30%', '25%', '5%']}
        />
      </FilesContainer>
    )
  }

  return <Container>{listFiles()}</Container>
}

ChooseFiles.propTypes = {
  files: PropTypes.array,
  beneficiariesToSelect: PropTypes.array,
  checkedBeneficiaries: PropTypes.array,
  getBeneficiariesToSelect: PropTypes.func.isRequired,
  checkBeneficiariesRead: PropTypes.func.isRequired,
  filesData: PropTypes.arrayOf(
    PropTypes.shape({
      confirmed: PropTypes.bool,
      examType: PropTypes.object,
      selectedBeneficiary: PropTypes.object,
      beneficiaryFileName: PropTypes.string,
      findStatus: PropTypes.number,
    })
  ).isRequired,
  setFilesData: PropTypes.func.isRequired,
}

ChooseFiles.defaultProps = {
  files: [],
  beneficiariesToSelect: [],
  checkedBeneficiaries: null,
}

const mapStateToProps = ({ beneficiary }) => ({
  beneficiariesToSelect: beneficiary.beneficiariesToSelect,
  checkedBeneficiaries: beneficiary.beneficiariesChecked,
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getBeneficiariesToSelect: getBeneficiariesAction,
    checkBeneficiariesRead: checkBeneficiariesReadAction,
  },
  dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(ChooseFiles)
